import { API_BASE_URL } from '../config';

export interface VideoRoom {
  meetingId: string;
  roomUrl: string;
  hostRoomUrl?: string;
  participantRoomUrl?: string;
  participantUrl?: string;
  viewerRoomUrl?: string;
  startDate: string;
  endDate: string;
}

export interface CreateRoomPayload {
  patientName?: string;
  deptId?: number | string;
  context?: string; // e.g. "hospital-consult" | "dept-consult"
}

class VideoApiService {
  private getHeaders(): HeadersInit {
    return { 'Content-Type': 'application/json' };
  }

  // ─── Create a new Whereby meeting room ────────────────────────────────────
  async createRoom(payload?: CreateRoomPayload): Promise<VideoRoom> {
    const res = await fetch(`${API_BASE_URL}/api/video/create-room`, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(payload || {}),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.message || 'Failed to create video room');
    }
    const data = await res.json();
    // Support both { data: {...} } and flat response shapes
    return data.data || data;
  }

  // ─── Get room details by meetingId ────────────────────────────────────────
  async getRoom(meetingId: string): Promise<VideoRoom> {
    const res = await fetch(`${API_BASE_URL}/api/video/room/${encodeURIComponent(meetingId)}`, {
      headers: this.getHeaders(),
    });
    if (!res.ok) throw new Error('Failed to fetch room details');
    const data = await res.json();
    return data.data || data;
  }

  // ─── Delete / end a meeting ───────────────────────────────────────────────
  async deleteRoom(meetingId: string): Promise<void> {
    await fetch(`${API_BASE_URL}/api/video/room/${encodeURIComponent(meetingId)}`, {
      method: 'DELETE',
      headers: this.getHeaders(),
    });
  }
}

const videoApiService = new VideoApiService();
export default videoApiService;
